var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScenarios(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 113.02",
    style: {
      enableBackground: "new 0 0 122.88 113.02"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M52.75,68.37c-7.63-6.3-17.48-9.41-29.54-9.35V44.02L0,67.81L23.21,90.9V77.76c9.07-0.05,15.78,2.48,20.14,7.61 c4.87,5.73,7.53,14.94,7.96,27.66l10.11-0.32l10.11,0.32c0.01-0.2,0.01-0.4,0.02-0.6h0.01v-0.35c0.53-12.23,3.17-21.12,7.92-26.71 c4.37-5.14,11.1-7.67,20.19-7.61V90.9l23.21-23.09L99.67,44.02v14.99c-11.32-0.06-20.69,2.66-28.11,8.19v-44h14.03L61.81,0 L38.72,23.21h14.03V68.37L52.75,68.37z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenarios);
export default __webpack_public_path__ + "static/media/scenarios.1837a37d.svg";
export { ForwardRef as ReactComponent };